import { COLORS, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const AppContainer = styled.div`
  .mobile-nav-sidebar {
    min-width: 89%;
  }
  .side-nav-sidebar {
    width: 240px;
  }
  .sidebar {
    padding-top: 0 !important;
  }
`;

export const TopBarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 4;
  width: 100%;
  padding: 20px 0;
  display: flex;
  align-items: center;
  background-color: ${COLORS.lightShadedGrey};
  clip-path: inset(0 0 -8px 0);
  box-shadow: 0 2px 4px 0 ${COLORS.black}1a;
  @media (max-width: 865px) {
    padding: 12px 0;
  }
`;

export const TopBarLogoContainer = styled.div`
  width: 240px;
  flex-shrink: 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  img {
    width: 120px;
    height: 21px;
    cursor: pointer;
  }

  @media (max-width: 865px) {
    width: auto;
    padding: 0 16px;
  }
`;

export const AppContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .ui.visible.left.overlay.sidebar {
    padding-top: 0 !important;
  }
`;

export const AppBodyContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const AppRoutesContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const TimelineContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  .timeline {
    margin: 0;
    padding: 0;
  }

  .form-proccess-top-main {
    margin: 0;
  }
`;

export const ProfileContainer = styled.div`
  cursor: pointer;
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 40px;
  align-items: center;
  justify-content: center;
  .profile-container__user-name {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    line-height: 26px;
  }
  .profile-container__right-icon {
    width: 24px;
    height: 24px;
  }
  .profile-container__profile-icon {
    width: 36px;
    height: 36px;
    cursor: pointer;
  }

  @media (max-width: 865px) {
    margin-right: 16px;
    gap: 8px;
    .profile-container__user-name {
      display: none;
    }
  }
`;
